function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Web",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "NKT-Overview",
  transform: "translate(-40.000000, -8.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-11"
}, /*#__PURE__*/React.createElement("g", {
  id: "header_logo",
  transform: "translate(40.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M162 50.3182C162 78.1081 109.863 123 109.863 123C109.863 123 61 78.1081 61 50.3182C61 22.5282 81.973 0 109.863 0C137.754 0 162 22.5282 162 50.3182ZM134 48.5C134 60.9264 123.926 71 111.5 71C99.0736 71 89 60.9264 89 48.5C89 36.0736 99.0736 26 111.5 26C123.926 26 134 36.0736 134 48.5ZM62.1994 82.5814C25.3476 89.853 0 105.023 0 122.558C0 147.166 49.9202 167.116 111.5 167.116C173.08 167.116 223 147.166 223 122.558C223 104.899 197.294 89.6391 160.019 82.4287C153.362 92.3399 145.155 102.137 137.305 110.679C145.692 113.556 151 117.811 151 122.558C151 131.223 133.315 138.247 111.5 138.247C89.6848 138.247 72 131.223 72 122.558C72 118.151 76.5755 114.168 83.9426 111.318C76.4573 102.67 68.5776 92.6883 62.1994 82.5814ZM0 205.442C0 190.462 18.4984 177.209 46.8646 169.131C54.5722 171.326 63.0084 173.139 72 174.5V213.952V214H72.0002C72.0647 222.643 89.7247 229.642 111.5 229.642C133.275 229.642 150.935 222.643 151 214H151V213.952V174.5C159.992 173.139 168.428 171.326 176.135 169.131C204.502 177.209 223 190.462 223 205.442C223 230.051 173.08 250 111.5 250C49.9202 250 0 230.051 0 205.442Z",
  id: "Fill-24"
})))));

function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "70px",
    viewBox: "0 0 220 280",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "header_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7eddfcb8.svg";
export { ForwardRef as ReactComponent };